const LinkedIn = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.7316 10.017V15.7315H12.4912V10.6715C12.4912 9.45832 12.4673 7.90998 10.8072 7.90998C9.12317 7.90998 8.86778 9.22687 8.86778 10.5837V15.7395H5.62744V5.31611H8.7321V6.71281C8.7321 6.72877 8.74806 6.73675 8.75604 6.73675C8.76402 6.73675 8.77201 6.72877 8.77999 6.72079C9.21895 5.90672 10.2725 5.05273 11.8368 5.05273C15.125 5.06072 15.7316 7.21562 15.7316 10.017Z"
        fill="white"
      />
      <path d="M3.62433 5.29199H0.328125V15.7632H3.62433V5.29199Z" fill="white" />
      <path
        d="M3.87959 2.00986C3.87959 3.05539 3.0256 3.90937 1.98007 3.90937C0.934542 3.90937 0.0805664 3.05539 0.0805664 2.00986C0.0805664 0.964334 0.934542 0.110352 1.98007 0.110352C3.0256 0.110352 3.87959 0.964334 3.87959 2.00986Z"
        fill="white"
      />
    </svg>
  );
};
export default LinkedIn;
